export enum StatusColor {
    PRIMARY = '#1770DA',
    SUCCESS = '#72CC03',
    WARNING = '#FF851B',
    ERROR = '#D00215',
    NORMAL = '#000000',
}
